import React from "react";

const QuietHero = ({ onOpenModal }) => (
  <section className="cursor-section settrhq-hero roofing-de-hero" data-testid="quiet-hero">
    <div className="cursor-container">
      <div className="cursor-hero-message" data-testid="quiet-headline">
        <p className="settrhq-hero-badge">YOUR NEW 24/7 ROOFING SALES EMPLOYEE</p>
        <h1 className="cursor-hero-h1">
          A <span className="settrhq-hero-gain">Digital Employee</span> Trained Exclusively for{" "}
          <span className="settrhq-hero-pain">Roofing Operations.</span>
        </h1>
        <p className="cursor-hero-subhead" data-testid="quiet-subheadline">
          Intercepts, qualifies, and books{" "}
          <strong className="settrhq-hero-emphasis">estimate inspections</strong> in under{" "}
          <strong className="settrhq-hero-speed">
            <span className="settrhq-hero-mono">26 seconds</span>
          </strong>
          {": 24 hours a day, 365 days a year. Trained on thousands of real job-site conversations."}
        </p>
      </div>

      <div className="settrhq-hero-cta">
        <button
          type="button"
          className="settrhq-hero-button"
          onClick={onOpenModal}
          data-testid="quiet-hero-cta"
        >
          Hire Your Roofing Digital Employee - 14 Days Free ↗
        </button>
      </div>
    </div>
  </section>
);

export default QuietHero;
